import { create, show, useModal } from "@ebay/nice-modal-react";
import { Suspense, useState } from "react";

import { Spinner } from "components/Spinner";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Modal from "ds/components/Modal";
import ModalContent from "ds/components/Modal/Content";
import ModalHeader from "ds/components/Modal/Header";
import Tab from "ds/components/Tab";

import { DEVTOOLS_MODAL_CONTENT_ID } from "./constants";
import Flags from "./flags";
import Performance from "./performance";
import Theme from "./theme";
import XRay from "./xRay/index";

const DevToolsModal = create(() => {
  const modal = useModal();
  const [tab, setTab] = useState("flags");

  return (
    <Modal
      size="large"
      role="alertdialog"
      isDismissable
      isOpen={modal.visible}
      onClose={modal.hide}
    >
      <ModalHeader title="DevTools" />
      <ModalContent id={DEVTOOLS_MODAL_CONTENT_ID}>
        <Box gap="medium" margin="0 0 x-large">
          <Tab label="Feature flags" id="flags" onClick={setTab} isActive={tab === "flags"} />
          <Tab label="Theme" id="theme" onClick={setTab} isActive={tab === "theme"} />
          <Tab label="X-ray" id="xray" onClick={setTab} isActive={tab === "xray"} />
          <Tab
            label="Performance"
            id="performance"
            onClick={setTab}
            isActive={tab === "performance"}
          />
        </Box>
        <Suspense
          fallback={
            <Box justify="center" padding="x-large 0">
              <Icon src={Spinner} size="large" />
            </Box>
          }
        >
          {tab === "flags" && <Flags />}
          {tab === "theme" && <Theme />}
          {tab === "xray" && <XRay />}
          {tab === "performance" && <Performance />}
        </Suspense>
      </ModalContent>
    </Modal>
  );
});

export const showDevToolsModal = () => show(DevToolsModal);
